export default "__VITE_ASSET__DemmjzLq__"